module.exports = __webpack_public_path__ + "img/nfi_slide_3.3bb03720.jpg";